export default __webpack_public_path__ + "static/media/43.dc8fc17a.png";